import {
	getFragmentsFromSelection,
	getLocalIdsFromSelection,
} from '@atlaskit/editor-common/selection';
import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { SelectionContext } from '@atlaskit/editor-common/types/selection';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { MalleableUiPlugin } from '../malleableUiPluginType';
import { normalizeRemixSelection } from '../utils/normalize-remix-selection';

export const normalizeRemixSelectionContext = (
	tr: Parameters<EditorCommand>[0]['tr'],
	api: ExtractInjectionAPI<MalleableUiPlugin> | undefined,
): SelectionContext | undefined => {
	if (
		!isExperimentEnabled('cc-ce-mau-remix-editor-selection-boundaries') ||
		api?.editorViewMode?.sharedState.currentState()?.mode === 'view'
	) {
		return undefined;
	}
	const selection = normalizeRemixSelection(tr.selection);
	if (selection === tr.selection) {
		return undefined;
	}
	tr.setSelection(selection);
	const context = api?.aiExperience?.actions.getAISelectionContext();
	return {
		...context,
		selectionFragment: getFragmentsFromSelection(selection),
		localIds: getLocalIdsFromSelection(selection),
		selectionMarkdown: null,
		startIndex: selection.$from.parentOffset,
		endIndex: selection.$to.parentOffset,
	};
};
